// extracted by mini-css-extract-plugin
export var component = "Agenda-module--component--d3830";
export var fadePop = "Agenda-module--fade-pop--07426";
export var growHeightIn = "Agenda-module--grow-height-in--1df79";
export var heading = "Agenda-module--heading--4a9b4";
export var row = "Agenda-module--row--e7592";
export var summary = "Agenda-module--summary--acfcd";
export var table = "Agenda-module--table--33f37";
export var tableWrapper = "Agenda-module--tableWrapper--85843";
export var time = "Agenda-module--time--cb0a8";